import { router, usePage } from '@inertiajs/react'
import { useEffect, useRef } from 'react'
import { toast } from 'sonner'

// Sprint 5b U8: the Tasks Kanban drag handler owns the toast UX for the
// subtask-blocked-from-Terminé case (it renders an action button linking
// to the parent's Show page). Skip the global auto-toast for that alert
// prefix so users don't see two toasts for the same failed drag — one
// raw "Sous-tâches ouvertes : N. ... [task_id=N]" and one rich one.
// Mirrors the prefix in
// app/frontend/pages/Work/Tasks/_components/TasksKanbanBoard.tsx.
const KANBAN_OWNED_ALERT_PREFIXES = ['Sous-tâches ouvertes']

function alertOwnedByConsumer(alert: string): boolean {
  return KANBAN_OWNED_ALERT_PREFIXES.some((prefix) => alert.startsWith(prefix))
}

function showFlash(flash: { notice?: string; alert?: string }) {
  if (flash.alert && !alertOwnedByConsumer(flash.alert)) toast.error(flash.alert)
  if (flash.notice) toast.success(flash.notice)
}

export function useFlash() {
  const { flash } = usePage()
  const toastShowed = useRef(false)

  useEffect(() => {
    if (!toastShowed.current) {
      toastShowed.current = true
      showFlash(flash)
    }
  }, [flash])

  useEffect(() => {
    return router.on('flash', (event) => {
      showFlash(event.detail.flash)
    })
  }, [])
}
